import React from 'react';

type Props = {
  value: string | number;
};

export const BlockCellRenderer = ({ value }: Props) => {
  if (!value) return null;

  return (
    <a
      href={`https://etherscan.io/block/${value}`}
      target="_blank"
      rel="noopener noreferrer"
      className="text-[#0584C3] hover:underline"
    >
      {value}
    </a>
  );
};
